export default "__VITE_ASSET__Dr4EApmP__"